module.exports = __webpack_public_path__ + "static/media/back-button-icon.e8a1f14e.svg";